import React from "react";
import { Route, Routes } from "react-router-dom";

import { AddUserPage } from "./addUser";
import { EditUserPage } from "./editUser";
import { UsersPage } from "./users";

export const UsersIndex: React.FC = () => {
  return (
    <Routes>
      <Route index element={<UsersPage />} />
      <Route path="add/*" element={<AddUserPage />} />
      <Route path=":id/edit/*" element={<EditUserPage />} />
    </Routes>
  );
};
